<template>
  <club-layout>
    <blue-panel />
    <div id="container">
      <div v-if="invoices && invoices.length">
        <table-blue :cols="cols">
          <tr v-for="(player, idx) in invoices" :key="player.playerId" :class="getTrClassName(player, idx)">
            <table-blue-label-date :timestamp="player.createdAt" />
            <table-blue-button-lock :locked="player.locked" :playerId="player.playerId"/>
            <table-blue-label-invoice :playerId="player.playerId" :invoice="player.invoice"/>
            <table-blue-label-balance :balance="player.balance" />
            <table-blue-label-insurance :insurance="player.insurance" />
            <table-blue-label-description :description="player.description" />
            <td style="text-align: right;">
              <table-blue-button-transfer :playerId="player.playerId" :visible="!player.locked" />
              <table-blue-button-close :playerId="player.playerId" :visible="!player.locked" />
              <table-blue-button-events :playerId="player.playerId" />
            </td>
          </tr>
        </table-blue>
        <table-blue-label-count :amount="invoices.length" />
      </div>
      <table-blue-no-result v-else />
    </div>
  </club-layout>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import TableBlue from './tables/TableBlue/TableBlue';
  import TableBlueButtonClose from './tables/TableBlue/TableBlueButtonClose';
  import TableBlueButtonEvents from './tables/TableBlue/TableBlueButtonEvents';
  import TableBlueButtonLock from './tables/TableBlue/TableBlueButtonLock';
  import TableBlueButtonTransfer from './tables/TableBlue/TableBlueButtonTransfer';
  import TableBlueLabelBalance from './tables/TableBlue/TableBlueLabelBalance';
  import TableBlueLabelInvoice from './tables/TableBlue/TableBlueLabelInvoice';
  import TableBlueLabelDate from './tables/TableBlue/TableBlueLabelDate';
  import TableBlueLabelDescription from './tables/TableBlue/TableBlueLabelDescription';
  import TableBlueLabelInsurance from './tables/TableBlue/TableBlueLabelInsurance';
  import TableBlueLabelCount from './tables/TableBlue/TableBlueLabelCount';
  import TableBlueNoResult from './tables/TableBlue/TableBlueNoResult';

  export default {
    name: "PlayerListPage",
    data() {
      return {
        cols: [
          { i18n: 'th.date', align: 'center' },
          { i18n: '', align: 'center' },
          { i18n: 'th.invoice', align: 'center' },
          { i18n: 'th.amount', align: 'right' },
          { i18n: 'th.insurance', align: 'right' },
          { i18n: 'th.description', align: 'center' },
          { i18n: 'th.operations', alight: 'right' },
        ]
      }
    },
    async created() {
      this.getClub();
    },
    methods: {
      ...mapActions(['getClub']),
      getTrClassName(player, idx) {
        if (player.locked) {
          return 'locked';
        }
        return idx % 2 === 0 ? 'odd': 'even';
      },
    },
    computed: {
      ...mapGetters(['invoices', 'currency']),
    },
    components: {
      TableBlue,
      TableBlueButtonClose,
      TableBlueButtonEvents,
      TableBlueButtonLock,
      TableBlueButtonTransfer,
      TableBlueLabelBalance,
      TableBlueLabelInvoice,
      TableBlueLabelDate,
      TableBlueLabelDescription,
      TableBlueLabelInsurance,
      TableBlueLabelCount,
      TableBlueNoResult,
    },
  }
</script>

<style scoped>
  #container {
    margin-top: 20px;
  }
</style>

